import React from 'react';
import { IndexRoute, Route } from 'react-router';
import SubdomainForm from './subdomainForm';

export default (
  <Route path="dominio-personalizado">
    <IndexRoute component={(props) => <SubdomainForm {...props} />} />
  </Route>
);
